var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-icon"},[_c('v-tooltip',{attrs:{"color":"primary","right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"depressed":"","fab":""}},'v-btn',_vm.$attrs,false),on),[_c('filter-icon',{attrs:{"size":"24px"}})],1)]}}])},[_c('span',[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }